module.exports = __webpack_public_path__ + "static/media/image19-example.4d06ae47.jpg";